import PropTypes from "prop-types";
export const UpiSoundboxItem = ({ image, titleheader, title, height }) => {
  return (
    <div className="flex  w-[427px] flex-col flex-wrap items-center  justify-center   px-[10px] pt-[10px] sm:w-full sm:pb-[0] ">
      <div className="mb-[20px] h-[100px] w-[100px] rounded-[100px] border-2 border-dashed border-[#565ADD] bg-white px-[14px] pb-[21px] pt-[4px]">
        <img className="py-[12px]" src={image} alt="Upi Sound Box Item" />
      </div>
      <div className={`min-h-[270px] sm:min-h-[190px] ${height} `}>
        <h3 className="text-center text-[24px] font-bold text-[#fff] ">
          {titleheader}{" "}
        </h3>
        <p className="text-4 max-w-[780px] text-center font-montserrat text-white">
          {title}
        </p>
      </div>
    </div>
  );
};
UpiSoundboxItem.propTypes = {
  image: PropTypes.string,
  titleheader: PropTypes.string,
  title: PropTypes.string,
  height: PropTypes.string,
};
